import apiClient from './apiClient';

export interface AdminUser {
    id: number;
    name: string;
    phone: string;
    is_phone_verified: boolean;
    is_admin: boolean;
    is_super_admin: boolean;
    created_at: string;
}

interface GetAdminUsersResponse {
    users: AdminUser[];
    total: number;
}

export interface GetAdminUsersParams {
    page?: number;
    per_page?: number;
    phone?: string;
}

export const getAdminUsers = async (params?: GetAdminUsersParams): Promise<{ users: AdminUser[]; total: number }> => {
    const response = await apiClient.get<GetAdminUsersResponse>('/api/admin/users', { params: params || {} });
    return { users: response.data.users, total: response.data.total };
};

export const updateUserRole = async (userId: number, isAdmin: boolean): Promise<void> => {
    await apiClient.put(`/api/admin/users/${userId}/role`, { is_admin: isAdmin });
};
